// ArcadeEmbed.tsx
import React from "react";

const RAW_SRC =
  "https://demo.arcade.software/uqGIabJYfDcUYErce6n4?embed&embed_mobile=tab&embed_desktop=inline&show_copy_link=true";

const ArcadeEmbed: React.FC<{ width?: string; heightIncremenet?: string }> = ({
  width = "75%",
  heightIncremenet = "41px",
}) => {
  // Force mobile to render inline instead of "Play" pop-out tab
  const src = React.useMemo(() => {
    try {
      const u = new URL(RAW_SRC);
      // keep desktop as inline (as you already had)
      u.searchParams.set("embed_desktop", "inline");
      // the important change: inline on mobile
      u.searchParams.set("embed_mobile", "inline");
      // keep the copy button if you want it
      u.searchParams.set("show_copy_link", "true");
      return u.toString();
    } catch {
      // fallback if URL constructor fails (unlikely)
      return RAW_SRC.replace("embed_mobile=tab", "embed_mobile=inline");
    }
  }, []);

  return (
    <>
      {/* Mobile-only sizing tweak; desktop remains identical */}
      <style>
        {`
          @media (max-width: 640px) {
            .arcade-embed { 
              width: 100% !important; 
              margin: 0 auto !important; 
              margin-top: 0 !important;
              height: 200px !important; 
              padding-bottom: 0 !important; 
              position: relative !important; 
            }
            .arcade-embed__frame { 
              position: absolute !important; 
              inset: 0 !important; 
              width: 100% !important; 
              height: 100% !important; 
              border: 0 !important; 
            }
          }
        `}
      </style>

      <div
        className="arcade-embed"
        style={{
          // === Desktop layout: unchanged from your working version ===
          position: "relative",
          paddingBottom: `calc(40.884353741496604% + ${heightIncremenet})`,
          height: 0,
          width: width,
          margin: "0 auto",
          marginTop: "-40px",
        }}
      >
        <iframe
          className="arcade-embed__frame"
          src={src}
          title="THE ARK - Workspace"
          loading="lazy"
          allowFullScreen
          allow="clipboard-write"
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            colorScheme: "light",
            border: 0,
          }}
        />
      </div>
    </>
  );
};

export default ArcadeEmbed;
